import classNames from "classnames";

import "./styles.scss";

const getColClasses = (col) => {
  if (typeof col === "object") {
    return Object.entries(col)
      .map(([key, val]) => `custom-box-col-${key}-${val}`)
      .join(" ");
  }
  return `custom-box-col-xs-${col}`;
};

const CustomGridItem = ({
  children,
  col = 12,
  containerClassName = "",
  containerStyle = {},
  className = "",
  style = {},
}) => {
  const colClass = getColClasses(col);

  const isEmpty = !children;

  return (
    <div
      className={classNames(
        "custom-box-grid-item",
        colClass,
        { "custom-box-grid-item-empty": isEmpty },
        containerClassName,
      )}
      style={containerStyle}>
      <div className={classNames("custom-box-grid-item-content", className)} style={style}>
        {children}
      </div>
    </div>
  );
};

export default CustomGridItem;
